import {
  AnalyticsTabs,
  CampaignTabSection,
  OverviewTabSection,
  TabSections,
  TabSectionType,
  TabType,
} from 'modules/iterableGoals/types';
import { generateSectionState } from 'modules/iterableGoals/utils';

/**
 * List of tab headers to be displayed on the page.
 */
export const tabs: TabType[] = [
  {
    id: AnalyticsTabs.OVERVIEW,
    label: 'tabs.analytics.overview',
  },
  {
    id: AnalyticsTabs.CAMPAIGNS,
    label: 'tabs.analytics.campaigns',
  },
];

export const defaultTab = AnalyticsTabs.OVERVIEW;

/**
 * Maps the sections to the tabs.
 */
export const tabSectionMap: Record<AnalyticsTabs, TabSectionType<TabSections>> = {
  [AnalyticsTabs.OVERVIEW]: generateSectionState(Object.values(OverviewTabSection)),
  [AnalyticsTabs.CAMPAIGNS]: generateSectionState(Object.values(CampaignTabSection)),
};
